module.exports = __webpack_public_path__ + "img/5.c84eb807.svg";